import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import TextRow from './TextRow';

const Anchor = styled.a`
  color: ${p => p.theme.color.textPrimary};
  font-family: ${p => p.theme.font.sourceSans};
  font-size: 16px;
  text-decoration: none;
  transition: color 180ms ease-in-out;

  &:hover {
    color: ${p => p.theme.color.primary};
  }

  @media ${p => p.theme.media.largePhone} {
    font-size: 12px;
  }
`;

const Link = ({ children, label, url }) => (
  <TextRow>
    {label}: <Anchor href={url}>{children || url}</Anchor>
  </TextRow>
);

Link.propTypes = {
  children: PropTypes.string,
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

export default Link;
